export class IndexerGrpcMegaVaultTransformer {
    static vaultResponseToVault(response) {
        const vault = response.vault;
        if (!vault) {
            return;
        }
        return {
            admin: vault.admin,
            lpDenom: vault.lpDenom,
            createdAt: vault.createdAt,
            updatedAt: vault.updatedAt,
            quoteDenom: vault.quoteDenom,
            contractName: vault.contractName,
            createdHeight: vault.createdHeight,
            updatedHeight: vault.updatedHeight,
            contractAddress: vault.contractAddress,
            contractVersion: vault.contractVersion,
            stats: vault.stats
                ? IndexerGrpcMegaVaultTransformer.grpcVaultStatsToVaultStats(vault.stats)
                : undefined,
            operators: vault.operators.map(IndexerGrpcMegaVaultTransformer.grpcOperatorToOperator),
            targetApr: vault.targetApr
                ? IndexerGrpcMegaVaultTransformer.grpcTargetAprToTargetApr(vault.targetApr)
                : undefined,
            incentives: vault.incentives
                ? IndexerGrpcMegaVaultTransformer.grpcIncentiveToIncentive(vault.incentives)
                : undefined,
        };
    }
    static userResponseToUser(response) {
        const user = response.user;
        if (!user) {
            return;
        }
        return {
            address: user.address,
            updatedAt: user.updatedAt,
            updatedHeight: user.updatedHeight,
            contractAddress: user.contractAddress,
            stats: user.stats
                ? IndexerGrpcMegaVaultTransformer.grpcUserStatsToUserStats(user.stats)
                : undefined,
        };
    }
    static subscriptionsResponseToSubscriptions(response) {
        return response.subscriptions.map(IndexerGrpcMegaVaultTransformer.grpcSubscriptionToSubscription);
    }
    static redemptionsResponseToRedemptions(response) {
        return response.redemptions.map(IndexerGrpcMegaVaultTransformer.grpcRedemptionToRedemption);
    }
    static operatorRedemptionBucketsResponseToOperatorRedemptionBuckets(response) {
        return response.buckets.map(IndexerGrpcMegaVaultTransformer.grpcOperatorRedemptionBucketToOperatorRedemptionBucket);
    }
    static tvlHistoryResponseToTvlHistory(response) {
        return response.history.map(IndexerGrpcMegaVaultTransformer.grpcHistoricalTVLToHistoricalTVL);
    }
    static pnlHistoryResponseToPnlHistory(response) {
        return response.history.map(IndexerGrpcMegaVaultTransformer.grpcHistoricalPnLToHistoricalPnL);
    }
    static grpcOperatorToOperator(operator) {
        return {
            address: operator.address,
            updatedAt: operator.updatedAt,
            percentage: operator.percentage,
            totalAmount: operator.totalAmount,
            subaccountId: operator.subaccountId,
            updatedHeight: operator.updatedHeight,
            totalLiquidAmount: operator.totalLiquidAmount,
        };
    }
    static grpcIncentiveToIncentive(incentive) {
        return {
            address: incentive.address,
            amount: incentive.amount,
            updatedAt: incentive.updatedAt,
            updatedHeight: incentive.updatedHeight,
        };
    }
    static grpcTargetAprToTargetApr(targetApr) {
        return {
            apr: targetApr.apr,
            updatedAt: targetApr.updatedAt,
            upperThreshold: targetApr.upperThreshold,
            lowerThreshold: targetApr.lowerThreshold,
            updatedHeight: targetApr.updatedHeight,
        };
    }
    static grpcVaultStatsToVaultStats(stats) {
        return {
            currentAmount: stats.currentAmount,
            currentLpPrice: stats.currentLpPrice,
            currentLpAmount: stats.currentLpAmount,
            totalRedeemedAmount: stats.totalRedeemedAmount,
            totalSubscribedAmount: stats.totalSubscribedAmount,
            currentAmountWithoutIncentives: stats.currentAmountWithoutIncentives,
            apr: stats.apr
                ? IndexerGrpcMegaVaultTransformer.grpcAprStatsToAprStats(stats.apr)
                : undefined,
            pnl: stats.pnl
                ? IndexerGrpcMegaVaultTransformer.grpcPnlStatsToPnlStats(stats.pnl)
                : undefined,
            volatility: stats.volatility
                ? IndexerGrpcMegaVaultTransformer.grpcVolatilityStatsToVolatilityStats(stats.volatility)
                : undefined,
            maxDrawdown: stats.maxDrawdown
                ? IndexerGrpcMegaVaultTransformer.grpcMaxDrawdownToMaxDrawdown(stats.maxDrawdown)
                : undefined,
        };
    }
    static grpcPnlStatsToPnlStats(pnl) {
        return {
            allTime: pnl.allTime
                ? IndexerGrpcMegaVaultTransformer.grpcPnlToPnl(pnl.allTime)
                : undefined,
            unrealized: pnl.unrealized
                ? IndexerGrpcMegaVaultTransformer.grpcUnrealizedPnlToUnrealizedPnl(pnl.unrealized)
                : undefined,
        };
    }
    static grpcUnrealizedPnlToUnrealizedPnl(pnl) {
        return {
            value: pnl.value,
            percentage: pnl.percentage,
        };
    }
    static grpcPnlToPnl(pnl) {
        return {
            value: pnl.value,
            percentage: pnl.percentage,
            currentAmount: pnl.currentAmount,
            totalAmountRedeemed: pnl.totalAmountRedeemed,
            totalAmountSubscribed: pnl.totalAmountSubscribed,
        };
    }
    static grpcMaxDrawdownToMaxDrawdown(maxDrawdown) {
        return {
            value: maxDrawdown.value,
            latestPnLPeak: maxDrawdown.latestPnLPeak,
        };
    }
    static grpcVolatilityStatsToVolatilityStats(volatility) {
        return {
            thirtyDays: volatility.thirtyDays
                ? IndexerGrpcMegaVaultTransformer.grpcVolatilityToVolatility(volatility.thirtyDays)
                : undefined,
        };
    }
    static grpcVolatilityToVolatility(volatility) {
        return {
            value: volatility.value,
        };
    }
    static grpcAprStatsToAprStats(apr) {
        return {
            thirtyDays: apr.thirtyDays
                ? IndexerGrpcMegaVaultTransformer.grpcAprToApr(apr.thirtyDays)
                : undefined,
        };
    }
    static grpcAprToApr(apr) {
        return {
            value: apr.value,
            currentLpPrice: apr.currentLpPrice,
            originalLpPrice: apr.originalLpPrice,
        };
    }
    static grpcUserStatsToUserStats(stats) {
        return {
            currentAmount: stats.currentAmount,
            currentLpAmount: stats.currentLpAmount,
            pnl: stats.pnl
                ? IndexerGrpcMegaVaultTransformer.grpcPnlStatsToPnlStats(stats.pnl)
                : undefined,
        };
    }
    static grpcSubscriptionsToSubscriptions(subscriptions) {
        return subscriptions.map(IndexerGrpcMegaVaultTransformer.grpcSubscriptionToSubscription);
    }
    static grpcSubscriptionToSubscription(subscription) {
        return {
            user: subscription.user,
            index: subscription.index,
            amount: subscription.amount,
            status: subscription.status,
            lpAmount: subscription.lpAmount,
            createdAt: subscription.createdAt,
            executedAt: subscription.executedAt,
            createdHeight: subscription.createdHeight,
            executedHeight: subscription.executedHeight,
            contractAddress: subscription.contractAddress,
        };
    }
    static grpcRedemptionToRedemption(redemption) {
        return {
            user: redemption.user,
            dueAt: redemption.dueAt,
            index: redemption.index,
            amount: redemption.amount,
            status: redemption.status,
            lpAmount: redemption.lpAmount,
            createdAt: redemption.createdAt,
            executedAt: redemption.executedAt,
            createdHeight: redemption.createdHeight,
            executedHeight: redemption.executedHeight,
            contractAddress: redemption.contractAddress,
        };
    }
    static grpcOperatorRedemptionBucketToOperatorRedemptionBucket(bucket) {
        return {
            bucket: bucket.bucket,
            neededAmount: bucket.neededAmount,
            lpAmountToRedeem: bucket.lpAmountToRedeem,
            missingLiquidity: bucket.missingLiquidity,
        };
    }
    static grpcHistoricalTVLToHistoricalTVL(history) {
        return {
            t: history.t,
            v: history.v,
        };
    }
    static grpcHistoricalPnLToHistoricalPnL(history) {
        return {
            t: history.t,
            v: history.v,
        };
    }
}
